import Component, { HeroImage as Image } from './hero.component'

export default Component
export type HeroImage = Image
